import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface WelcomeCardProps {
  onExit: () => void;
  onExplore: () => void;
}

export const WelcomeCard = (props: WelcomeCardProps) => {
  return (
    <Card className="fixed left-1/2 top-1/2 min-w-sm max-w-lg -translate-x-1/2 -translate-y-1/2">
      <CardHeader>
        <CardTitle>Welcome to Our Easement Data Prototype</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <p>
          Explore sample data from Kambah, ACT. This demo showcases the various
          types of easement data we offer and how easements interact with
          parcels and the built environment. Feel free to navigate around and
          share your feedback.
        </p>
        <p>
          Our dataset provides the most comprehensive, aggregated, and
          standardised representation of easements across Australia—offering
          what each jurisdiction and government agency provides. While NT and SA
          data are currently unavailable, our coverage remains the best national
          view of easements.
        </p>
        <p>
          If you're interested in exploring the full product, don't hesitate to
          get in touch!
        </p>
      </CardContent>
      <CardFooter className="justify-end gap-2">
        <Button variant="ghost" onClick={props.onExit}>
          Exit
        </Button>
        <Button onClick={props.onExplore}>Explore</Button>
      </CardFooter>
    </Card>
  );
};
